import Menu from "@mui/material/Menu";
import React from "react";
import { Avatar, Divider, IconButton, ListItemIcon, MenuItem, Paper } from "@mui/material";
import { Logout, Dashboard, Person, Assessment, Construction } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { BaseUser } from "../types";

interface ProfileButtonProps {
    logout: () => void;
    user: BaseUser;
    teamIconComponent?: React.ComponentType<{ team_name: string; sx?: any }>;
    routes?: {
        profile?: string;
        manageOrg?: string;
        staffDashboard?: string;
        playerDashboard?: string;
        metricsDetails?: string;
        utils?: string;
    };
}

export default function ProfileButton(props: ProfileButtonProps) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [open, setOpen] = React.useState(false);
    const navigate = useNavigate();
    
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setOpen(true);
    };
    
    const handleClose: any = () => {
        setAnchorEl(null);
        setOpen(false);
    };

    const TeamIcon = props.teamIconComponent;
    const defaultRoutes = {
        profile: '/profile',
        manageOrg: '/manage-org',
        staffDashboard: '/staff-dashboard',
        playerDashboard: '/player-dashboard',
        metricsDetails: '/metrics-details',
        utils: '/utils',
    };
    const routes: typeof defaultRoutes = {
        profile: props.routes?.profile ?? defaultRoutes.profile,
        manageOrg: props.routes?.manageOrg ?? defaultRoutes.manageOrg,
        staffDashboard: props.routes?.staffDashboard ?? defaultRoutes.staffDashboard,
        playerDashboard: props.routes?.playerDashboard ?? defaultRoutes.playerDashboard,
        metricsDetails: props.routes?.metricsDetails ?? defaultRoutes.metricsDetails,
        utils: props.routes?.utils ?? defaultRoutes.utils,
    };

    return (
        <React.Fragment>
            <IconButton 
                onClick={handleClick} 
                size="small" 
                sx={{ ml: 2 }} 
                aria-controls={open ? 'account-menu' : undefined} 
                aria-haspopup="true" 
                aria-expanded={open ? 'true' : undefined}
            >
                <Avatar sx={{ width: 32, height: 32 }} />
            </IconButton>
            <Menu 
                anchorEl={anchorEl} 
                open={open} 
                onClose={handleClose} 
                onClick={handleClose} 
                PaperProps={{ 
                    elevation: 0, 
                    sx: { 
                        overflow: 'visible', 
                        mt: 1.5, 
                        minWidth: 180, 
                        boxShadow: '0px 0px 20px #00000044', 
                        borderRadius: 2 
                    } 
                }} 
                transformOrigin={{ horizontal: 'right', vertical: 'top' }} 
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <Paper>
                    <MenuItem onClick={() => { navigate(routes.profile); handleClose(); }}>
                        <Avatar sx={{ mr: 1 }} /> Profile
                    </MenuItem>
                    {props.user.is_org_owner && (
                        <MenuItem onClick={() => { navigate(routes.manageOrg); handleClose(); }}>
                            {TeamIcon && <TeamIcon team_name={props.user.team} sx={{mr: 1}}/>}
                            Organization
                        </MenuItem>
                    )}
                    <Divider />
                    {props.user.is_staff ? (
                        <MenuItem onClick={() => { navigate(routes.staffDashboard); handleClose(); }}>
                            <Dashboard sx={{ mr: 1 }} /> Staff Dashboard
                        </MenuItem>
                    ) : (
                        <MenuItem onClick={() => { navigate(routes.playerDashboard); handleClose(); }}>
                            <Person sx={{ mr: 1 }} /> Player Dashboard
                        </MenuItem>
                    )}
                    <MenuItem onClick={() => { navigate(routes.metricsDetails); handleClose(); }}>
                        <Assessment sx={{ mr: 1 }} /> Metrics Details
                    </MenuItem>
                    <MenuItem onClick={() => { navigate(routes.utils); handleClose(); }}>
                        <Construction sx={{ mr: 1 }} /> Utils
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={props.logout}>
                        <ListItemIcon>
                            <Logout fontSize="small" />
                        </ListItemIcon>
                        Logout
                    </MenuItem>
                </Paper>
            </Menu>
        </React.Fragment>
    );
}

